import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { lazyImport } from '@helpers'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withSkeletonTheme,
  withStaffPickImage,
  withSuspense,
  withTheme,
} from '@hocs'

const { SimilarProductsSlider } = lazyImport(
  () => import('@components/SimilarProductsSlider/SimilarProductsSlider'),
  'SimilarProductsSlider',
)

const relatedAndComplementaryProductsEl = document.getElementById(
  'related-and-complementary-products',
)
const productHandle = relatedAndComplementaryProductsEl?.getAttribute(
  'data-product-handle',
)

export const renderRelatedProductsApp = (relatedProductsSettingsJson: any) => {
  if (
    relatedAndComplementaryProductsEl &&
    relatedProductsSettingsJson?.enabled
  ) {
    const RelatedProductsApp = () => (
      <SimilarProductsSlider
        productHandle={productHandle || ''}
        slidesSize="lg"
      />
    )

    const RelatedProductsAppWrapper = pipe(
      RelatedProductsApp,
      withSuspense,
      withStaffPickImage,
      withExchangeRates,
      withSkeletonTheme,
      withI18next,
      withApollo,
      withErrorBoundary,
      withTheme,
    )

    ReactDOM.createRoot(relatedAndComplementaryProductsEl).render(
      <RelatedProductsAppWrapper />,
    )
  }
}
